import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.object.assign";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import { apiRunner, apiRunnerAsync } from "./api-runner-browser";
import React, { createElement } from "react";
import ReactDOM from "react-dom";
import { Router, navigate } from "@reach/router";
import { ScrollContext } from "gatsby-react-router-scroll";
import domReady from "@mikaelkristiansson/domready";
import { shouldUpdateScroll, init as navigationInit, RouteUpdates } from "./navigation";
import emitter from "./emitter";
import PageRenderer from "./page-renderer";
import asyncRequires from "./async-requires";
import { setLoader, ProdLoader } from "./loader";
import EnsureResources from "./ensure-resources";
import stripPrefix from "./strip-prefix"; // Generated during bootstrap

import matchPaths from "./match-paths.json";
var loader = new ProdLoader(asyncRequires, matchPaths);
setLoader(loader);
loader.setApiRunner(apiRunner);
window.asyncRequires = asyncRequires;
window.___emitter = emitter;
window.___loader = loader;
window.___webpackCompilationHash = window.webpackCompilationHash;
navigationInit();
apiRunnerAsync("onClientEntry").then(function () {
  // Let plugins register a service worker. The plugin just needs
  // to return true.
  if (apiRunner("registerServiceWorker").length > 0) {
    require("./register-service-worker");
  }

  var RouteHandler =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(RouteHandler, _React$Component);

    function RouteHandler() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = RouteHandler.prototype;

    _proto.render = function render() {
      var _this = this;

      var location = this.props.location;
      return React.createElement(EnsureResources, {
        location: location
      }, function (_ref) {
        var pageResources = _ref.pageResources,
            location = _ref.location;
        return React.createElement(RouteUpdates, {
          location: location
        }, React.createElement(ScrollContext, {
          location: location,
          shouldUpdateScroll: shouldUpdateScroll
        }, React.createElement(PageRenderer, Object.assign({}, _this.props, {
          location: location,
          pageResources: pageResources
        }, pageResources.json))));
      });
    };

    return RouteHandler;
  }(React.Component);

  var _window = window,
      pagePath = _window.pagePath,
      browserLoc = _window.location; // Explicitly call navigate if the canonical path (window.pagePath)
  // is different to the browser path (window.location.pathname). But
  // only if NONE of the following conditions hold:
  //
  // - The url matches a client side route (page.matchPath)
  // - it's a 404 page
  // - it's the offline plugin shell (/offline-plugin-app-shell-fallback/)

  if (pagePath && __BASE_PATH__ + pagePath !== browserLoc.pathname && !(loader.pathFinder.findMatchPath(stripPrefix(browserLoc.pathname, __BASE_PATH__)) || pagePath === "/404.html" || pagePath.match(/^\/404\/?$/) || pagePath.match(/^\/offline-plugin-app-shell-fallback\/?$/))) {
    navigate(__BASE_PATH__ + pagePath + browserLoc.search + browserLoc.hash, {
      replace: true
    });
  }

  loader.loadPage(browserLoc.pathname).then(function (page) {
    if (!page || page.status === "error") {
      throw new Error("page resources for " + browserLoc.pathname + " not found. Not rendering React");
    }

    var Root = function Root() {
      return createElement(Router, {
        basepath: __BASE_PATH__
      }, createElement(RouteHandler, {
        path: "/*"
      }));
    };

    var WrappedRoot = apiRunner("wrapRootElement", {
      element: React.createElement(Root, null)
    }, React.createElement(Root, null), function (_ref2) {
      var result = _ref2.result;
      return {
        element: result
      };
    }).pop();

    var NewRoot = function NewRoot() {
      return WrappedRoot;
    };

    var renderer = apiRunner("replaceHydrateFunction", undefined, ReactDOM.hydrate)[0];
    domReady(function () {
      renderer(React.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
        apiRunner("onInitialClientRender");
      });
    });
  });
});